import _extends from "@babel/runtime/helpers/esm/extends";
import React from "react";
import { ProFormGroup } from '../../../layouts';
export var group = function group(item, _ref) {
  var genItems = _ref.genItems;

  if (item.valueType === 'group') {
    var _item$getFieldProps;

    if (!item.columns || !Array.isArray(item.columns)) return null;
    return /*#__PURE__*/React.createElement(ProFormGroup, _extends({
      key: item.key,
      label: item.label,
      colProps: item.colProps,
      rowProps: item.rowProps
    }, (_item$getFieldProps = item.getFieldProps) === null || _item$getFieldProps === void 0 ? void 0 : _item$getFieldProps.call(item)), genItems(item.columns));
  }

  return true;
};